import Header from "./Header"
import Main from "./Main"
import Footer from "./Footer"
function Layout() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  )
}

export default Layout